module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_DA-6629449f837de1797dcafc70b4cacb8f.svg";